<template>
  <el-dialog
    title="审核成功"
    :visible.sync="visible"
    :append-to-body="true"
    width="30%"
    style="margin-left: 10px;">
    <div style="text-align: left; margin-bottom: 30px">
      <span><i class="el-icon-success"
               style="color: lightgreen"></i>{{this.recommendOrderCount.note}}</span>
    </div>
    <template v-if="!isIntern">
      <div>
        <div>
          同<span class="red-text">批次</span>下任务：
          <div class="group">
            <el-radio v-model="recommendType"
                      v-if="orderDetail.marketid > 0"
                      label="batch-market">
              <span>同<span class="red-text">门店</span>剩余{{this.recommendOrderCount.batch.market}}单待审核</span>
            </el-radio>
          </div>
          <div class="group">
            <el-radio v-model="recommendType"
                      label="batch-user">
              <span>同<span class="red-text">零工</span>剩余{{this.recommendOrderCount.batch.user}}单待审核</span>
            </el-radio>
          </div>
          <div class="group">
            <el-radio v-model="recommendType"
                      label="batch-substep">
              <span>同<span class="red-text">模板</span>剩余{{this.recommendOrderCount.batch.template}}单待审核</span>
            </el-radio>
          </div>
          <div class="group">
            <el-radio v-model="recommendType"
                      label="batch-total">
              <span><span class="red-text">总计</span>：剩余{{this.recommendOrderCount.batch.total}}单待审核</span>
            </el-radio>
          </div>
        </div>
      </div>
      <div>
        <div style="margin-top: 20px;">
          同<span class="red-text">项目</span>下任务：
          <div class="group">
            <el-radio v-model="recommendType"
                      v-if="orderDetail.marketid > 0"
                      label="project-market">
              <span>同<span class="red-text">门店</span>剩余{{this.recommendOrderCount.project.market}}单待审核</span>
            </el-radio>
          </div>
          <div class="group">
            <el-radio v-model="recommendType"
                      label="project-user">
              <span>同<span class="red-text">零工</span>剩余{{this.recommendOrderCount.project.user}}单待审核</span>
            </el-radio>
          </div>
          <div class="group">
            <el-radio v-model="recommendType"
                      label="project-substep">
              <span>同<span class="red-text">模板</span>剩余{{this.recommendOrderCount.project.template}}单待审核</span>
            </el-radio>
          </div>
          <div class="group">
            <el-radio v-model="recommendType"
                      label="project-total">
              <span><span class="red-text">总计</span>：剩余{{this.recommendOrderCount.project.total}}单待审核</span>
            </el-radio>
          </div>
        </div>
      </div>
    </template>
    <div style="margin-top: 50px; margin-left: 160px;">
      <router-link :to="backToListRoute">
        <el-button type="success"
                   size="mini">返回列表
        </el-button>
      </router-link>
      <el-button class="group-button"
                 type="primary"
                 size="mini"
                 @click="getRecommendOrder()">审核下一单
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {},
  props: {
    recommendOrderCount: Object,
    orderDetail: Object,
  },
  data () {
    return {
      visible: false,
      recommendType: 'batch-user', // 默认选中 批次-用户 条件
      /** 实习生：依据审单配置解析；null 表示尚未加载完成 */
      isProjectAuditMode: null,
    }
  },
  computed: {
    ...mapState({
      user: state => state.login.user,
    }),
    isIntern () {
      return parseInt(this.user && this.user.usertype, 10) === 4
    },
    backToListRoute () {
      if (this.isIntern) {
        if (this.isProjectAuditMode === true) {
          return {path: '/customer/project-order-review/table'}
        }
        if (this.isProjectAuditMode === false) {
          return {
            path: '/customer/batch-order-review/table',
            query: {
              customerid: this.orderDetail.customerid,
              projectId: this.orderDetail.projectid
            },
          }
        }
        return {path: '/audit-task/table'}
      }
      return {
        path: '/order/table',
        query: {batchid: this.orderDetail.batchid, status: ['4'], reformat: 1, per_page: 50, current_page: 1},
      }
    },
  },
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    async loadAuditTaskSettingMode () {
      const pid = parseInt(this.orderDetail && this.orderDetail.projectid, 10)
      if (!pid) {
        this.isProjectAuditMode = false
        return
      }
      try {
        const {data} = await request.page('queryAuditTaskSetting', {
          projectid: pid,
          status: 1,
          current_page: 1,
          per_page: 1,
        })
        const row = data && data.data && data.data[0]
        const cfg = row && row.setting_config_json
        this.isProjectAuditMode = cfg ? parseInt(cfg.is_project_audit, 10) === 1 : false
      } catch (e) {
        this.isProjectAuditMode = false
      }
    },
    open (recOrderCount) {
      this.visible = true
      if (this.isIntern) {
        this.recommendType = 0
        this.loadAuditTaskSettingMode()
        return
      }
      // 若同批次下同用户的待审核工单数量小于 1，则将 recommendType 重置回 0
      if (recOrderCount && recOrderCount.batch && recOrderCount.batch.user < 1) {
        this.recommendType = 0
      }
      let recommendType = sessionStorage.getItem('recommendType')
      if (recommendType != null) {
        this.recommendType = recommendType
      }
    },
    goToOrderReview (orderId) {
      const nextOrderId = Number(orderId)
      const currentOrderId = Number(this.$route.params.id)
      if (nextOrderId === currentOrderId) {
        this.$router.go(0)
        return
      }
      this.$router.push({
        path: '/order/review/' + nextOrderId,
      })
    },
    async getRecommendOrder () {
      if (this.isIntern) {
        await this.loadAuditTaskSettingMode()
        let payload

        const projectid = Number(this.orderDetail.projectid)
        if (this.isProjectAuditMode) {
          payload = {projectid}
        } else {
          const batchid = Number(this.orderDetail.batchid)
          payload = {projectid, batchid}
        }
        request.common('createAuditTask', payload).then(({data}) => {
          this.goToOrderReview(data.orderid)
        })
        return
      }

      if (!this.recommendType) {
        await this.$alert('请选择审核类型', '提示', {type: 'error'})
        return
      }
      let recommend = this.recommendType.split('-')
      let type = recommend[0]
      let filter = recommend[1]

      // 判断任务是否为23(宴席类)，如果是则调用 getRecommendBanquetOrderApi 接口
      const apiName = this.orderDetail.type + '' === '23' ? 'getRecommendBanquetOrderApi' : 'getRecommendOrder'
      request.common(apiName, {
        batchid: this.orderDetail.batchid,
        projectid: this.orderDetail.projectid,
        marketid: this.orderDetail.marketid,
        userid: this.orderDetail.userid,
        type: type,
        filter: filter,
        orderid: this.orderDetail.orderid,
        templateid: this.orderDetail.templateid
      }).then((data) => {
        sessionStorage.setItem('recommendType', this.recommendType)
        if (data.data > 0) {
          this.goToOrderReview(data.data)
        } else {
          this.$alert('无待审核的工单', '提示', {type: 'error'})
        }
      })
    }
  },
}
</script>

<style scoped>

.group {
  margin-top: 15px;
  margin-left: 30px;
}

.group-button {
  float: right;
  margin-right: 35px;
}

.red-text {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/RecommendOrder.vue